import './home.css';
import LandingPage from './landingPage/landingPage'
import ToolKit from './toolKit/toolKit';
import Plans from './plans/plans';
import InAction from './inAction/inAction';

// page assets

import WaveBackground from '../../../assets/waveBackground/waveBackground';

export default function Home({isMobile}) {
    
    return(
        <div>
            <WaveBackground isMobile={isMobile}/>
            <LandingPage isMobile={isMobile}/>
            <ToolKit isMobile={isMobile}/>
            <Plans isMobile={isMobile}/>
            <InAction isMobile={isMobile}/>
        </div>
    )
};